// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6acbdd78","501":"c12fe0b0","667":"548342bd","977":"1d247e10"}[chunkId] + ".chunk.js";
};